import React from 'react';
import { classes, style } from 'typestyle';
import { ArtistSchema } from '../../../types/schema';
import { percent, px } from 'csx';
import { mediaDesktop, mediaUpToDesktop } from '../utilities/mediaQueries';
import { rebrand } from '../../../theme/color';
import { ArtistProfileImage } from './ArtistProfileImage';
import { resetAnchorStyles } from '../../../theme/reset';

const styles = {
  wrapper: style({
    position: 'relative',
    paddingBottom: px(32),
  }),
  zeroPaddingBottom: style({
    paddingBottom: 0,
  }),
  artistInfo: style({
    marginTop: '12px',
    $nest: {
      '& a': {
        ...resetAnchorStyles,
      },
      '& a:hover': {
        textDecoration: 'underline',
      },
    },
  }),
  artistInfoSmall: style(
    {
      position: 'absolute',
      bottom: px(10),
      zIndex: 50,
      fontSize: px(12),
      fontWeight: 600,
    },
    mediaUpToDesktop({
      width: 'calc(100% - 16px)',
    }),
    mediaDesktop({
      width: percent(100),
    })
  ),
  name: style({
    fontWeight: 700,
    fontSize: px(16),
    color: rebrand.contrast[50].toString(),
    display: 'block',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  }),
  type: style({
    fontSize: px(16),
    fontWeight: 400,
    color: rebrand.neutralOnLight[70].toString(),
  }),
};

export type ArtistTileProps = {
  className?: string;
  artist: ArtistSchema;
  isSearchPage?: boolean;
  onClick?: () => void;
};

export const NonActiveArtistTile: React.FC<ArtistTileProps> = ({
  className,
  artist,
  isSearchPage = false,
  onClick,
}) => {
  return (
    <div onClick={onClick} className={classes(styles.wrapper, isSearchPage && styles.zeroPaddingBottom, className)}>
      <ArtistProfileImage artist={artist} />

      {isSearchPage ? (
        <div className={styles.artistInfo}>
          <span className={styles.name}>{artist.name}</span>
          <span className={styles.type}>Artist</span>
        </div>
      ) : (
        <>
          <div className={styles.artistInfoSmall}>{artist.name}</div>
        </>
      )}
    </div>
  );
};
